<template>
  <!-- 首页精选商品 -->
  <ul class="fvlrw loyaltyBox" v-if="list?.length">
    <li class="fhlud" v-for="(item, index) in list" :key="index" @click.stop="toLink(item)">
      <div class="descriptionBox ">
        <van-image :src="item.bannerUrl" width="100%" height="100%">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
        <p class="description ellipsisRowTwo">{{ item.description }}</p>
      </div>
      <p class="tipsBox">
        <span v-if="item?.type === 1">{{ item?.tips }}</span>
        <span v-if="item?.type === 2"
          >你有卡券 <span class="themeColor"> {{ item?.cardNumber }} </span> 张</span
        >
      </p>
    </li>
  </ul>
</template>

<script>
import { reactive, toRefs } from 'vue'

import { useRouter } from 'vue-router'
export default {
  props: ['datas'],
  setup(props) {
    let { datas } = toRefs(props)
    const router = useRouter()
    const state = reactive({
      list: datas
    })
    const toLink = ({ path, categoryCode }) => {
      console.log('toLink', path, categoryCode)
      if(categoryCode=='TireProduct'){
         router.push({ path: '/tyreList', query: { from: 'home', event: '轮胎列表' } })
      }else{
          router.push({
          path,
          query: { categoryCode, from: 'home', event: '查看精选商品列表' }
        })
      }
    }

    return {
      ...toRefs(state),
      toLink
    }
  }
}
</script>

<style lang="scss" scoped>
.loyaltyBox {
  width: 100%;
  // overflow-x: scroll;
  margin: 0;
  li {
    width: 48%;
    margin-bottom: 20px;
    background: #fff;
    text-align: center;
    border-radius: 4px;
    overflow: hidden;
  }
  .descriptionBox {
    position: relative;
    height: 100px;
    width: 100%;
    p {
      position: absolute;
      bottom: 0;
      left: 0;
      max-height: 60px;
      width: 100%;
      padding: 0 10px;
      line-height: 28px;
      color: #fff;
      box-sizing: border-box;
      background-color: rgba(1, 1, 1, 0.3);
    }
  }
  .tipsBox {
    padding: 5px 10px;
    height: 46px;
    line-height: 20px;
    box-sizing: border-box;
  }
  .discountStr {
    margin: 2px 0;
  }
  .left {
    background: rgb(48, 136, 197);
    color: #fff;
    padding: 5px;
    box-sizing: border-box;
    flex-direction: column;
  }
  .right {
    max-width: 65px;
    height: 60px;
    color: rgb(51, 51, 51);
    font-size: 12px;
    text-align: left;
    padding: 0 8px;
    background-color: #eee;
  }
  .condition {
    font-size: 12px;
  }
  .discount {
    font-size: 12px;
    font-weight: bold;
  }
  .thresholdStr {
    word-break: normal;
  }
}
</style>
